export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[650px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cream%20toned%20abstract%20lifestyle%20composition%20with%20soft%20overlapping%20circular%20shapes%20and%20gentle%20flowing%20ribbons%2C%20subtle%20product%20silhouettes%20in%20distance%2C%20sophisticated%20modern%20aesthetic%2C%20editorial%20quality%20with%20refined%20textures%20and%20delicate%20grain%2C%20warm%20beige%20sand%20and%20terracotta%20palette%2C%20airy%20spacious%20feel%20with%20balanced%20negative%20space%2C%20high%20end%20brand%20visual%20identity%20style%2C%20artistic%20minimalism%20with%20depth%20and%20dimension&width=1800&height=1200&seq=hero-bg-kakobuy-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet Polska tło"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/8 to-background-50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col items-center text-center w-full">
          {/* Trust Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm border border-background-200/50 mb-6 animate-[fadeInUp_0.6s_ease-out]">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-verified-badge-line text-primary-500 text-sm"></i>
            </div>
            <span className="text-xs md:text-sm font-medium text-foreground-800 whitespace-nowrap">
              #1 Polski przewodnik Kakobuy Spreadsheet 2026
            </span>
          </div>

          {/* H1 */}
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 max-w-4xl leading-tight mb-4 animate-[fadeInUp_0.6s_ease-out_0.1s]">
            Kakobuy Spreadsheet Polska – Najlepsza Lista Produktów i Przewodnik Zakupów 2026
          </h1>

          {/* Subtitle */}
          <p className="text-sm md:text-lg text-background-50/85 max-w-2xl mb-8 animate-[fadeInUp_0.6s_ease-out_0.2s] leading-relaxed">
            Odkrywaj najlepsze produkty z <strong>Kakobuy Spreadsheet</strong>. Gotowe listy produktów, kategorie, poradniki oraz aktualne informacje dla użytkowników z Polski.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center gap-3 mb-10 animate-[fadeInUp_0.6s_ease-out_0.3s]">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25 hover:shadow-primary-500/40"
            >
              Kakobuy Spreadsheet
              <i className="ri-arrow-right-line text-base"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-900 text-sm md:text-base font-semibold hover:bg-background-50 transition-all duration-300 cursor-pointer whitespace-nowrap border border-background-200/50"
            >
              Buy It Now
              <i className="ri-shopping-bag-line text-base"></i>
            </a>
          </div>

          {/* Trust Items */}
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 animate-[fadeInUp_0.6s_ease-out_0.4s]">
            {[
              { icon: 'ri-refresh-line', text: 'Aktualizowane listy produktów' },
              { icon: 'ri-global-line', text: 'Polska wersja językowa' },
              { icon: 'ri-book-open-line', text: 'Kompletny przewodnik zakupowy' },
              { icon: 'ri-shield-check-line', text: 'Bezpieczne wskazówki' },
            ].map((item) => (
              <div
                key={item.text}
                className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-background-50/10 backdrop-blur-sm border border-background-50/15"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.icon} text-secondary-300 text-xs`}></i>
                </div>
                <span className="text-xs text-background-50/80 whitespace-nowrap">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-[bounce_2s_infinite]">
        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm cursor-pointer">
          <i className="ri-arrow-down-line text-background-50 text-sm"></i>
        </div>
      </div>
    </section>
  );
}